export const MESSAGE_TIMEOUT = 5000;
export const MESSAGE_TIMEOUT_3S = 3000;
export const USER_CARD_EDIT_BUTTON_INACTIVE_TIMEOUT = 3000;
export const SECONDS_TO_MILLISECONDS_FOR_CONVERTING_JS_DATE = 1000;
export const LOADING_TIMEOUT = 300;
export const MAX_ATTEMPTS_COUNT = 3;
export const SCAN_ME_LOGO = 'assets/svg/scanMeLogoSingleNew.svg';
export const DEFAULT_USER_ICON = 'assets/svg/defaultUserIcon.svg';
export const DEFAULT_INITIAL_COUNTRY = 'am';
export const DEFAULT_ITI_POLITE = 'polite';
export const LOWERCASE_LETTERS = 'abcdefghijklmnopqrstuvwxyz';
export const UPPERCASE_LETTERS = 'ABCDEFGHIJKLMNOPQRSTUVWXYZ';
export const DIGITS = '0123456789';
export const SPECIAL_CHARACTERS = '@$/!%*#?&+=._-';
export const ENGLISH_ROUTES_FOR_PLACEHOLDER = ['/cards', '/cards/edit', '/history', '/teams', '/activity'];
export const ADD_CONTENT_SUCCESS_ALERT_TEXT = 'alert.addContentSuccess'
export const REQUEST_PAYMENT_DIALOG = 'requestPaymentDialog'
export const ADD_CREDIT_CARD_DIALOG = 'addCreditCardDialog'
export const CREDIT_CARDS_DIALOG = 'creditCardsDialog'
export const SUBSCRIPTION_ALREADY_EXISTED_MESSAGE = 'You are on a different plan. Cancel it to buy a new subscription.';
export const CREATE_CARD_LIMIT_ERROR_ALERT = "create_card_limit_error";
export const TEAM_SUBSCRIPTION_EXPIRY_ERROR_ALERT = "Your team subscription has expired. Please get a new one to continue.";
export const URL_COPY_SUCCESS_ALERT = "URL successfully copied․";
export const VERIFICATION_ALERT_FOR_ACTIVATING_ACCOUNT = "Your account is not verified. Please verify to log in.";
export const MAX_SEND_VERIFICATION_CODE_ATTEMPTS = "Only 3 attempts available. Try to register and log in in 24 hours.";
export const CREDIT_CARD_DETAILS_REQUIRED_MESSAGE = "Before proceeding with your request, please add your credit card details to your profile․";
export const DEFAULT_CARD_SINGLE_PAGE_LINK_PREFIX = "/q/";
export const USER_CARD_DUPLICATION_MESSAGE = "User card successfully duplicated.";
export const DUPLICATE_MONEY_LUX_UUID_MESSAGE = "Only one payment is allowed, regardless of the method.";
export const REMEMBER_ADDRESS = "rememberAddress";
export const IS_BUSINESS_SUCCESSFULLY_MESSAGE = "Business status updated successfully";
export const IS_BUSINESS_FAILED_MESSAGE = "Failed to update business status";
export const PAYMENT_FAILURE_MESSAGE  = "Payment failed. Please try again or choose a different method.";
export const PAYMENT_LOAD_ERROR_MESSAGE  = "Failed to load. Try again.";
export const DEFAULT_COMMISSION = 5;
export const PAYMENT_QR_IDENTIFICATION_ID = "paymentQrIdentificationId";
export const RESERVED_IDENTIFICATION_ID = "reservedIdentificationId";
export const QR_CODE_GENERATION_ERROR_MESSAGE  = "QR code could not be generated. Please try again later.";
export const QR_CODE_GET_ERROR_MESSAGE  = "Cannot get QR codes. Please try again later.";
export const PAY_URL_COPY_SUCCESS_ALERT = "Shareable link copied!";
export const OVERVIEW_VALID_TABS = ['ALL_MEMBERS', 'GROUPS', 'SUBGROUPS', 'MENTORS'] as const;

